import React from 'react';
import { TagsList } from '../../components/TagsList';
import { useTags } from '../../contexts/TagsContext';
import './TagsPage.scss';

export const TagsPage = () => {
  const { 
    tags, 
    loading, 
    error, 
    createNewTag, 
    updateExistingTag, 
    deleteExistingTag 
  } = useTags();

  if (loading) {
    return (
      <div className="tagsPage">
        <div className="tagsPage__loading">Loading tags...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tagsPage">
        <div className="tagsPage__error">
          <h2>Error loading tags</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tagsPage">
      <TagsList
        tags={tags || []}
        onCreate={createNewTag}
        onUpdate={updateExistingTag}
        onDelete={deleteExistingTag}
      />
    </div>
  );
};